var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAutomatizado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 62,
    viewBox: "0 0 67 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 49.3333C2.66602 48.4493 3.0172 47.6014 3.64233 46.9763C4.26745 46.3512 5.11529 46 5.99935 46H62.666C63.5501 46 64.3979 46.3512 65.023 46.9763C65.6482 47.6014 65.9993 48.4493 65.9993 49.3333V61H2.66602V49.3333Z",
    stroke: "#353435",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3333 21H51L41 11L51 1H64.3333",
    stroke: "#353435",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 17.6673C11.3486 17.6673 14.3333 14.6825 14.3333 11.0007C14.3333 7.31875 11.3486 4.33398 7.66667 4.33398C3.98477 4.33398 1 7.31875 1 11.0007C1 14.6825 3.98477 17.6673 7.66667 17.6673Z",
    stroke: "#353435",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 11H41M11 17.6667L24.3333 46",
    stroke: "#353435",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutomatizado);
export default __webpack_public_path__ + "static/media/icon_automatizado.f92c0bb9df9ac92e35ccfcb6a49d8b19.svg";
export { ForwardRef as ReactComponent };